import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chatter-provided-set',
  templateUrl: './chatter-provided-set.component.html',
  styleUrls: ['./chatter-provided-set.component.scss']
})
export class ChatterProvidedSetComponent {
  @Input()
  public setToProvide: any[];

  @Output()
  public itemSelected: EventEmitter<any> = new EventEmitter<any>();

  public selected: any;

  public select(item: any): void {
    this.selected = item;
    this.itemSelected.emit(item);
  }
}
